import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { RevenueByNetworkServices } from "../../../../services";
import {
  FETCH_REVENUE_BY_NETWORK_INIT,
  FETCH_REVENUE_BY_NETWORK_LIST,
  EXPORT_REVENUE_BY_NETWORK,
  TOAST,
  SET_REVENUE_BY_NETWORK_FILTERS,
  CLEAR_REVENUE_BY_NETWORK_FILTERS,
} from "../../../types/Reservations/RevenueByNetwork.type";

export const initializeRevenueByNetworkScreen = () => ({
  type: FETCH_REVENUE_BY_NETWORK_INIT,
});

export const fetchRevenueByNetworkStart = (payload) => ({
  type: FETCH_REVENUE_BY_NETWORK_LIST.START,
  payload,
});

export const fetchRevenueByNetworkSuccess = (payload) => ({
  type: FETCH_REVENUE_BY_NETWORK_LIST.SUCCESS,
  payload,
});

export const fetchRevenueByNetworkError = (payload) => ({
  type: FETCH_REVENUE_BY_NETWORK_LIST.ERROR,
  payload,
});

export const fetchRevenueByNetwork = (payload) => {
  return (dispatch) => {
    dispatch(fetchRevenueByNetworkStart(payload));
    RevenueByNetworkServices.fetchRevenueByNetwork(payload).then((data) => {
      if (!data.isError) {
        dispatch(fetchRevenueByNetworkSuccess(data));
      } else {
        dispatch(fetchRevenueByNetworkError(data));
      }
    });
  };
};

export const exportRevenueByNetwork = (payload) => {
  return (dispatch) => {
    dispatch({ type: EXPORT_REVENUE_BY_NETWORK.START });
    RevenueByNetworkServices.exportRevenueByNetworkRecord(payload).then(
      (data) => {
        if (!data.isError) {
          dispatch({
            type: EXPORT_REVENUE_BY_NETWORK.SUCCESS,
            payload: data,
          });
        } else {
          dispatch({
            type: EXPORT_REVENUE_BY_NETWORK.ERROR,
            payload: data,
          });
        }
        setTimeout(() => {
          dispatch(resetToast());
        }, DEFAULT_TOAST_LIFE + 1000);
      }
    );
  };
};

export const resetToast = () => ({
  type: TOAST.RESET,
});

export const setRevenueByNetworkFilters = (filters) => ({
  type: SET_REVENUE_BY_NETWORK_FILTERS,
  payload: filters,
});

export const clearRevenueByNetworkFilters = () => ({
  type: CLEAR_REVENUE_BY_NETWORK_FILTERS,
});
